"use client";

interface DashboardDetailsWrapperProps {
  title: string;
  onBack: () => void;
  children: React.ReactNode;
}

export const DashboardDetailsWrapper: React.FC<
  DashboardDetailsWrapperProps
> = ({ title, children }) => {
  return (
    <div className="mb-4 flex w-full flex-col md:mt-8 md:mb-16">
      {title && (
        <div className="hidden pb-4 md:block">
          <span className="font-bold text-lg">{title}</span>
        </div>
      )}
      {children}
    </div>
  );
};
